import { render, staticRenderFns } from "./exchange-confirm-order.vue?vue&type=template&id=1a25059a&scoped=true&"
import script from "./exchange-confirm-order.vue?vue&type=script&lang=js&"
export * from "./exchange-confirm-order.vue?vue&type=script&lang=js&"
import style0 from "./exchange-confirm-order.vue?vue&type=style&index=0&id=1a25059a&prod&lang=scss&"
import style1 from "./exchange-confirm-order.vue?vue&type=style&index=1&id=1a25059a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a25059a",
  null
  
)

export default component.exports